import { useNavigate,useLoaderData } from "react-router";
import { useParams } from "react-router";
import {useMemo,useEffect,useState,useRef,useCallback } from 'react'
import {useGetProcessFromInstanceQuery,usePublishProcessInstanceDataMutation,useLoadUserQuery,
		useCompleteProcessStateMutation,databaseViewApi,
		useListInstanceFormsQuery,useListInstanceStateDataQuery,useGetOrgInfoQuery,
		useCreateProcessStateEntryMutation,
		useCloseExecutionMutation} from './redux/databaseView';
import {useDispatch,useSelector} from 'react-redux';
import { Stack } from '@mui/material';
import Button from '@mui/material/Button';
import {CommentBox} from './CommentBox';
import {MemberBox} from './MemberBox';
import {RenderDocument,updateField,setInitialFormState} from './RenderForm';
import {setFormDataMerge} from './redux/appState'
import Alert from '@mui/material/Alert';
import {WaitingElement} from './AddUserDialog';
import {saveFormInstance} from './formPersistence'
import {processTable} from './tableProcessing'
import {isoToMysql} from './utils/generalUtils';
import {advanceState,completeProcess} from './stateTraversal.js';

import {initialiseFormData} from './formLoader.js';
import {loadProcess} from './processLoader.js';
function RelatedForms({instance,state})
	{
	const formData=useListInstanceFormsQuery({instance});
	var items=[{name:"current"}];
	if (formData.isSuccess)
		items=[...formData.data.data];
	items=items.filter((x)=>(x.state!==state));
	if (!items.length)
		return null;
	return (<><h3>Related forms</h3>
			<Stack style={{height:200,maxHeight:200,overflowY:'auto'}}>
				{items.map((x,idx)=>
					{
					var href="/data/"+instance+"/"+x.state;
					return (<div key={idx} style={{textAlign:'left',borderWidth:1,borderColor:'black',borderStyle:'solid'}}>
								<Stack ><a href={href}>{x.name}</a></Stack>
								<Stack style={{ fontSize:'70%'}}>{(x.timestamp)?x.timestamp:null}</Stack>
							</div>)
					})
				}
			</Stack>
			</>);	
	}
	
	
function VersionBox({instance,state})
	{
	const revisions=useListInstanceStateDataQuery({instance,state});
	var items=[{timestamp:"current"}];
	if (revisions.isSuccess)
		items=[...revisions.data.data];
//	items=items.filter((x)=>(x.state!=state));
	if (!items.length)
		return null;
	return (<>
			<h3>Other Submitted data</h3>
			<Stack style={{height:200,maxHeight:200,overflow:'auto'}}>
				{items.map((x,idx)=>
					{
					var href="/data/"+instance+"/"+state+"/"+x.id;
					return (<div key={idx} style={{borderWidth:1,borderColor:'black',marginTop:1,marginBottom:1,borderStyle:'solid'}}>
								<Stack><a href={href}>{x.timestamp}</a></Stack>
							</div>);
					})
				}
			</Stack>
			</>);		
	}


	
	
export function ProcessExecute()
	{
	const effectRan = useRef(false);
	const [processState,setProcessState]=useState(null);
	const dispatch=useDispatch();
	const [waiting,setWaiting]=useState(false);
	const {instance:instanceID,state:activeState,version:dataVersion} = useParams(); // read from URL path
	const [actionText,setActionText]=useState("Loading");
	const userData=useLoadUserQuery();	
	const processInfo=useGetProcessFromInstanceQuery({instanceID});
	const navigator=useNavigate();
	const loaderData=useLoaderData();
	var [publishProcessInstanceData]=usePublishProcessInstanceDataMutation();
	const [addProcessStateEntry]=useCreateProcessStateEntryMutation();
	const [completeProcessState]=useCompleteProcessStateMutation();
	const mergeData=useSelector((state)=>state.appState.formDataMerge);
	const formData=useRef({});
	const {data:orgData}=useGetOrgInfoQuery();
	const [completeExecution]=useCloseExecutionMutation();
	const loadData=useCallback(async ()=>
		{
		var mergedData={...formData.current,...mergeData}
		await dispatch(setInitialFormState(mergedData));
		formData.current=mergedData;
		await dispatch(setFormDataMerge(null));
		},[dispatch,mergeData])
		
	const initialiseProcess=useCallback(async ()=>
		{
		setWaiting(true);
		setActionText("Loading form");

		async function prepareFormData(siteSettings)
			{
			var data=await initialiseFormData(dispatch,instanceID,activeState,dataVersion);

			if (data)
				data={...data};
			else
				data={};

			data.projectNumber=loaderData.project;
			data.zzTeamList=siteSettings.functionalAreas.map((x)=>({value:x.area,label:x.area}));

			await dispatch(setInitialFormState(data));

			return data;
			}


		var processId=processInfo.data.data.descriptor;
		var state=await loadProcess(dispatch,processId,activeState);

		if (state.processName==null)
			{
			setWaiting(false);
			return;
			}

		var siteSettings=JSON.parse(orgData.data.siteSettings);
		formData.current=await prepareFormData(siteSettings);

		setProcessState(state);
		setWaiting(false);
		},[activeState,dispatch,orgData?.data?.siteSettings,processInfo.data?.data?.descriptor,dataVersion, instanceID,loaderData.project])	

	
	const validUserList=useMemo(()=>
		{
		if (!userData.isSuccess)
			return {};

		var users={};

		userData.data.data.forEach((x)=>
			{
			var areas=x.areas?JSON.parse(x.areas):{};
			users[x.id]={...x,areas};
			});

		return users;
		},[userData]);
	
	useEffect(()=>
		{
		if (!processInfo.isSuccess||!orgData?.data?.siteSettings||!userData.isSuccess)
			return;

		if (!effectRan.current)
			{
			effectRan.current=true;
			initialiseProcess();
			}

		return ()=>
			{
			effectRan.current=false;
			setProcessState(null);
			}
		},[userData.isSuccess,processInfo.isSuccess,initialiseProcess,instanceID,activeState,dataVersion,userData.fulfilledTimeStamp,processInfo.fulfilledTimeStamp,orgData?.data?.siteSettings]);
	
	async function cancelInstance()
		{
		setWaiting(true);
		await completeProcess(dispatch,instanceID,"cancelled");
		navigator("/");
		}

	const validUsers=useMemo(()=>
		{
		if (!processState)
			return [];

		return Object.values(validUserList)
			.filter((user)=>user.areas[processState.ownerGroup])
			.map((user)=>({
				value:user.id,
				displayName:user.displayName,
				label:user.name
				}));
		},[validUserList,processState]);

	useEffect(() => {
		dispatch(updateField({field:'userList',value:validUsers}));
		}, [validUsers,dispatch]);
		
	useEffect(()=>{
		if (mergeData!=null)
			loadData()
		}, [mergeData,loadData]);
		

	async function updateProcessMetadata()
		{
		if (formData.current.ZZassignment)
			{
			await dispatch(databaseViewApi.endpoints.addAssignment.initiate({
				teamName:processState.ownerGroup,
				staffName:formData.current.ZZassignment,
				instanceID
				}));
			}

		if (formData.current.ZZprocessDue)
			{
			await dispatch(databaseViewApi.endpoints.setInstanceDueDate.initiate({
				instance:instanceID,
				due:isoToMysql(formData.current.ZZprocessDue),
				prefix:formData.current.ZZprocessPrefix
				}));
			}
		}


	async function submitProcess()
		{
		setWaiting(true);
		setActionText("Submitting");
		
		var combinedData=await saveFormInstance(processState,formData.current,instanceID,activeState,true,publishProcessInstanceData);
		await updateProcessMetadata();

		await advanceState(
			dispatch,
			processState,
			instanceID,
			activeState,
			completeProcessState,
			addProcessStateEntry,
			combinedData
			);
		if (combinedData[" executionID"])
			completeExecution({executionID:combinedData[" executionID"]});
		setWaiting(false);
		navigator("/");
		}


	async function attachTable(id)
		{
		if (!id.tableKey)
			return;

		return processTable(dispatch,processState.schema,formData,id,instanceID);
		}

	async function processButtons(id)
		{
		var label=id.label?.toLowerCase();
		if (label==="changeprefix")
			{
			var redoPrefix=await dispatch(databaseViewApi.endpoints.updatePrefix.initiate({
				instance:instanceID,
				prefix:id.value
				}));

			return redoPrefix.data?.data;
			}


		if (label==="attach"||id.action==="attach")
			{
			return attachTable(id);
			}

		var myPromises=[];
		myPromises.push(new Promise(resolve=>setTimeout(resolve,250)));
		if (label==="save")
			{
			await saveFormInstance(processState,formData.current,instanceID,activeState,false,publishProcessInstanceData);
			}
		else if (label==="submit"||label==="complete")
			{
			await submitProcess();
			}

		return Promise.all(myPromises);
		}


	return (
		<div
			style={{
				flex: 1,
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				minHeight: 0,
				overflow: 'hidden'
			}}
		>

			<Stack
				style={{
					alignItems: 'center',
					display: 'flex',
					flexShrink: 0,
					position: 'relative'
				}}
				direction="row"
			>
				{processInfo.data?.data?.ownerAccess &&
					<Button
						color="warning"
						variant="contained"
						style={{
							zIndex: 10,
							margin: 10
						}}
						onClick={cancelInstance}
					>
						Cancel Process
					</Button>
				}

				{processState &&
					<>
						<h1
							style={{
									position: 'absolute',
									left: 0,
									right: 250,
									textAlign: 'center',
									marginTop: 0,
									marginBottom: 0,
									pointerEvents: 'none'
								}}
								>
							{processState.processName}
						</h1>

					</>
				}
			</Stack>


			{mergeData != null &&
				<Alert
					severity="warning"
					style={{flexShrink: 0}}
					action={
						<Stack direction="row">
							<Button
								onClick={loadData}
								color="inherit"
								size="small"
							>
								Load
							</Button>

							<Button
								onClick={() => dispatch(setFormDataMerge(null))}
								color="inherit"
								size="small"
							>
								Ignore
							</Button>
						</Stack>
					}
				>
					Form data was found on the server, should I load it for you?
				</Alert>
			}


			<div
				style={{
					flex: 1,
					display: 'flex',
					flexDirection: 'row',
					minHeight: 0,
					overflow: 'hidden'
				}}
			>

				{/* FORM - this is the only part that scrolls */}
				<div
					style={{
						flex: '0 1 1400px',
						width: '100%',
						maxWidth: 1400,
						minWidth: 0,
						overflowY: 'auto'
					}}
				>
					<div
						style={{
							width: '100%',
							maxWidth: 1400,
							marginLeft: 0,
							marginRight: 'auto',
							paddingLeft: 24,
							paddingRight: 24,
							boxSizing: 'border-box'
						}}
					>
					<WaitingElement
						actionText={actionText}
						waiting={waiting}
						size={1}
					>
						{!waiting&& processState &&
							<RenderDocument
								formData={formData}
								clickFunction={processButtons}
								schema={processState.schema}
							/>
						}
					</WaitingElement>
					</div>
				</div>


				{/* RIGHT PANEL - stays in position */}
				<div
					style={{
						flex: '1 1 250px',
						minWidth: 250,
						maxWidth: 300,
						paddingLeft: 16,
						paddingRight: 10,
						boxSizing: 'border-box'
					}}
				>
					<h3>Team</h3>
					<MemberBox
						userList={validUserList}
						instance={instanceID}
					/>

					<h3>Comments</h3>
					<CommentBox instance={instanceID}/>

					<RelatedForms
						instance={instanceID}
						state={activeState}
					/>

					<VersionBox
						instance={instanceID}
						state={activeState}
					/>
				</div>
			</div>
		</div>
	);
}


	
	

	
